import React from 'react';
import './Sub-services.css';
import man1 from './assets/Man-tan1.png';
import man2 from './assets/man_tan2.png';

const InstalacionHeatPipe = () => {
  return (
    <div className="containerSer">
      <h2>
        INSTALACIÓN Y SUMINISTRO DE SISTEMAS DE CALENTAMIENTO SOLAR HEAT PIPE
      </h2>
      <p>
        Los sistemas de calentamiento solar tipo Heat Pipe son equipos altamente
        eficientes que utilizan tubos al vacío con tecnología de transferencia
        térmica para calentar agua mediante la radiación solar. Funcionan sin
        consumo eléctrico y son ideales para viviendas, negocios, hoteles,
        gimnasios y más, de igual pueden tener un respaldo eléctrico a través de
        controladores inteligentes.
      </p>
      <div className="subservice-gallery">
        <img
          // Added objectFit
          src={man1}
          alt="tanque solar previo al mantenimiento"
          className="panel-sucio-image"
        />
        <img
          // Added objectFit
          src={man2}
          alt="tanque solar posterior al mantenimiento"
          className="panel-sucio-image"
        />
      </div>
      <p>
        Ofrecemos el servicio de diseño, suministro e instalación de sistemas
        solares de calentamiento de agua adaptados a tus necesidades
        específicas. este servicio incluye: estudio de demanda de agua caliente,
        selección del sistema más adecuado; instalación técnica profesional,
        capacitación para el uso eficiente del equipo; acompañamiento postventa
        y mantenimiento preventivo.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Reducción significativa del consumo de energía eléctrica o gas.</li>
        <li>Ahorros económicos a mediano y largo plazo.</li>
        <li>Funcionamiento eficiente incluso en días nublados.</li>
        <li>Cero emisiones al ser una tecnología limpia y sostenible.</li>
        <li>Incremento del valor de tu propiedad.</li>
        <li>Tranquilidad garantizada al dejar el proceso en manos expertas</li>
      </ul>
    </div>
  );
};

export default InstalacionHeatPipe;
